export const modal = (): void => {
  (function(window, document, $) {
    const $modalElements = $("[data-js-modal]");
    if ($modalElements.length === 0) {
      return;
    }

    const modalVideos = $modalElements.filter("[data-js-modal=\"video\"]");
    const modalImage = $modalElements.filter("[data-js-modal=\"image\"]");
    const modalInline = $modalElements.filter("[data-js-modal=\"inline\"]");
    if (modalVideos.length > 0) {
      modalVideos.modaal({
        type: "video"
      });
    }
    if (modalImage.length > 0) {
      modalImage.modaal({
        type: "image"
      });
    }
    if (modalInline.length > 0) {
      modalInline.modaal({});
    }

  })(window, document, jQuery);
};